<template>
    <div class="animated fadeIn">
        <section class="hero is-medium has-border-bottom-gray">
            <div class="hero-body">
                <div class="container">
                    <div class="columns is-centered is-vcentered">
                        <div class="column has-padding-top-2x-mobile">
                            <div class="columns is-centered">
                                <div class="columns is-centered is-vcentered contact-us-header-mailbox is-mobile">
                                    <div class="column is-narrow padding-top-2x-mobile">
                                        <figure class="image manifesto-splash" v-if="!isMobile()">
                                            <img alt="Manifesto splash" src="./assets/manifesto-splash.svg">
                                        </figure>
                                        <figure class="image manifesto-splash mobile-screen" v-else>
                                            <img alt="Manifesto splash" src="./assets/manifesto-splash.svg">
                                        </figure>
                                    </div>
                                </div>
                            </div>
                            <div class="columns is-centered padding-top-2x">
                                <h1 class="title is-size-2 has-text-centered-mobile padding-bottom-1x uptin-text-center">
                                    {{ $t('manifesto:manifesto.titles.title') }}
                                </h1>
                            </div>
                            <div class="columns is-centered">
                                <h2 class="is-size-5 has-text-centered-mobile uptin-text-center small-container">
                                    {{ $t('manifesto:manifesto.titles.main') }}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="hero-footer">
                <div class="box is-shadowless">
                    <p class="has-text-centered">
                        <span class="tag is-rainbow"> {{ $t('manifesto:manifesto.common.reading_time') }}</span> &nbsp;&nbsp; ۶ {{ $t('manifesto:manifesto.common.reading_time_minutes') }}
                    </p>
                </div>
            </div>
        </section>
        <section class="section" id="TOC">
            <div class="small-container">
                <div class="content is-medium">
                    <div class="has-text-centered">
                        <h2 class="title is-3 is-spaced is-margin-top-small uptin-text-center">
                          {{ $t('manifesto:manifesto.titles.toc') }}
                        </h2>
                    </div>
                    <br/>
                    <ul>
                        <li>
                            <a href="#why" v-scroll-to="'#why'">
                                {{ $t('manifesto:manifesto.titles.why') }}
                            </a>
                        </li>
                        <li>
                            <a href="#manifesto" v-scroll-to="'#manifesto'">
                                {{ $t('manifesto:manifesto.titles.manifesto') }}
                            </a>
                            <ul>
                                <li>
                                    <a href="#honest" v-scroll-to="'#innovation'">
                                        {{ $t('manifesto:manifesto.titles.innovation') }}
                                    </a>
                                </li>
                                <li>
                                    <a href="#honest" v-scroll-to="'#honest'">
                                        {{ $t('manifesto:manifesto.titles.honest') }}
                                    </a>
                                </li>
                                <li>
                                    <a href="#revenue" v-scroll-to="'#revenue'">
                                        {{ $t('manifesto:manifesto.titles.revenue') }}
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        <section class="section" id="why">
            <div class="small-container">
                <div class="content is-medium">
                    <div class="has-text-centered">
                        <h2 class="title is-3 is-spaced is-margin-top-small uptin-text-center">
                          {{ $t('manifesto:manifesto.goals.title') }}
                        </h2>
                        <h4 class="subtitle is-6 uptin-text-center">
                          {{ $t('manifesto:manifesto.goals.subtitle') }}
                        </h4>
                    </div>
                    <br/>
                    <p>
                         <strong> {{ $t('manifesto:manifesto.goals.text_1') }}</strong>
                    </p>
                    <p class="is-size-6 uptin-text-7 manifesto-text">
                         {{ $t('manifesto:manifesto.goals.text_2') }}
                    </p>

                </div>
            </div>
        </section>
        <section class="section" id="manifesto">
            <div class="small-container">
                <div class="content is-medium">
                    <div class="has-text-centered">
                        <h2 class="title is-3 is-spaced is-margin-top-small uptin-text-center">
                          {{ $t('manifesto:manifesto.manifest.title') }}
                        </h2>
                        <h4 class="subtitle is-6 uptin-text-center">
                           {{ $t('manifesto:manifesto.manifest.subtitle') }}
                        </h4>
                    </div>

                    <h3 id="innovation">
                        {{ $t('manifesto:manifesto.manifest.header_1') }}
                    </h3>
                    <p class="is-size-6 uptin-text-7 manifesto-text">
                        {{ $t('manifesto:manifesto.manifest.text_1') }}
                    </p>

                    <h3 id="honest">
                      {{ $t('manifesto:manifesto.manifest.header_2') }}
                    </h3>
                    <p class="is-size-6 uptin-text-7 manifesto-text">
                        {{ $t('manifesto:manifesto.manifest.text_2') }}
                    </p>

                    <h3 id="revenue">
                        {{ $t('manifesto:manifesto.manifest.header_3') }}
                    </h3>
                    <p class="is-size-6 uptin-text-7 manifesto-text">
                         {{ $t('manifesto:manifesto.manifest.text_3') }}
                    </p>
                </div>
            </div>
        </section>

        <download-app></download-app>
        <pay-as-you-go></pay-as-you-go>
    </div>
</template>

<style lang="scss">
    .manifesto-text {
        text-align: justify;
        text-justify: inter-word;
    }

    .manifesto-splash {
        max-width: 1000px;
        min-width: 1000px;
        height: auto;

        &.position-top {
            top: -1em;
        }

        &.mobile-screen {
            max-width: 400px;
            min-width: 200px;
        }
    }

</style>

<script>

    import PayAsYouGo from "@/components/pay-as-you-go/pay-as-you-go"
    import DownloadApp from "@/components/download-app/download-app"

    export default {
        name: 'uptin-manifesto',
        components: {
            PayAsYouGo,
            DownloadApp
        },
        data() {
            return {
            }
        },
        methods: {
            isMobile() {
                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return true
                } else {
                    return false
                }
            }
        }
    }
</script>
